import { Component } from '@angular/core'

import { LeaseDetailService } from '../../data/services/view/lease-detail.service'

interface RatioRowKey {
	rowIndex: number
	category: string
	label: string
	indent: number
	isCategory: boolean
	format: 'percentage' | 'number' | 'currency'
}

/**
 * ADR-0021 — Render dinámico de Ratios Anuales.
 * Itera `ratiosData.ratiosPeriods[i].rows[]` con labels dinámicos del Excel.
 */
@Component({
	selector: 'app-financial-ratios',
	templateUrl: './financial-ratios.component.html',
	styleUrls: ['./financial-ratios.component.scss'],
})
export class FinancialRatiosComponent {
	constructor(public leaseDetailService: LeaseDetailService) {}

	get periods(): any[] {
		const r = this.leaseDetailService.ratiosData as any
		return Array.isArray(r?.ratiosPeriods) ? r.ratiosPeriods : []
	}

	get hasData(): boolean {
		return this.periods.length > 0
	}

	get mergedRows(): RatioRowKey[] {
		const map = new Map<number, RatioRowKey>()
		for (const p of this.periods) {
			for (const r of p.rows || []) {
				if (!map.has(r.rowIndex)) {
					map.set(r.rowIndex, {
						rowIndex: r.rowIndex,
						category: r.category || '',
						label: r.label,
						indent: r.indent || 0,
						isCategory: !!r.isCategory,
						format: (r.format as RatioRowKey['format']) || 'number',
					})
				}
			}
		}
		return Array.from(map.values()).sort((a, b) => a.rowIndex - b.rowIndex)
	}

	getValue(period: any, rowIndex: number): number | null {
		const row = period.rows?.find((r: any) => r.rowIndex === rowIndex)
		return row?.value ?? null
	}

	trackByRowIndex(_idx: number, r: RatioRowKey): number {
		return r.rowIndex
	}

	trackByPeriod(_idx: number, p: any): number {
		return p.year
	}
}
